import React, {FC} from "react";
import {IconButton, makeStyles, Typography, TypographyProps} from "@material-ui/core";
import {format} from "date-fns";
import {Skeleton} from "@material-ui/lab";
import {EditOutlined as EditIcon, Event} from "@material-ui/icons";
import {useHistory, useRouteMatch} from "react-router-dom";

const useStyles = makeStyles(() => ({
    captionContainer: {
        display: 'flex',
        flexDirection: 'row',
        alignItems: 'center',
    },
    nameIcon: {
        paddingTop: 3.4,
        paddingRight: 4
    },
    valueContainer: {
        display: 'flex',
        alignItems: 'center',
        flexWrap: 'wrap',
    }
}));

interface DateDisplayProps {
    date?: number | null;
    label: string;
    required?: boolean;
    dateFormat?: string;
    typographyProps?: TypographyProps;
    className?: string;
    editIdentifier?: string;
}

export const DateDisplay: FC<DateDisplayProps> = ({
                                                      label,
                                                      required,
                                                      date,
                                                      dateFormat = "dd.MM.yyyy - HH:mm",
                                                      className,
                                                      editIdentifier
                                                  }) => {
    const classes = useStyles();
    const history = useHistory();
    const {url} = useRouteMatch();
    return (
        <div className={className}>
            <div className={classes.captionContainer}>

                <Typography
                    variant="caption"
                    color="textSecondary"
                    className={classes.nameIcon}
                >
                    <Event fontSize="small" color="inherit"/>
                </Typography>

                <Typography variant="caption" color="textSecondary">
                    {label}
                </Typography>
            </div>
            {(date || !required)
                ? (
                    <div className={classes.valueContainer}>
                        <Typography>
                            {date && format(new Date(date), dateFormat)}
                        </Typography>
                        {editIdentifier && (
                            <IconButton
                                size="small"
                                onClick={() => history.replace(`${url}?mode=edit#${editIdentifier}`)}
                            >
                                <EditIcon fontSize="inherit"/>
                            </IconButton>
                        )}
                    </div>
                )
                : <Skeleton width={224}/>
            }
        </div>
    )
}

